import React from 'react';
import { Link } from 'react-router-dom';
import { HomeNavLogo } from './HomeNavLogo';
import { HomeNavDesktopMenu } from './HomeNavDesktopMenu';
import { HomeNavMobileMenu } from './HomeNavMobileMenu';
import { HomeNavFreeTrial } from './HomeNavFreeTrial';
export function HomeNavigation() {
  return <nav className="fixed top-0 left-0 right-0 z-50 bg-black shadow-lg transition-all duration-300" data-id="element-1169">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2" data-id="element-1170">
        <div className="flex justify-between items-center" data-id="element-1171">
          <HomeNavLogo data-id="element-1172" />

          <div className="hidden md:flex items-center gap-8" data-id="element-1173">
            <HomeNavDesktopMenu data-id="element-1174" />
            <HomeNavFreeTrial data-id="element-1175" />
          </div>

          <HomeNavMobileMenu data-id="element-1176" />
        </div>
      </div>
      {/* Announcement Banner */}
      <div className="hidden md:block border-t border-gray-800/50" data-id="element-1177">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2 text-center" data-id="element-1178">
          <Link to="/womens-self-defense-seminar-april-18-2026/p/womens-self-defense-workshop-toys-for-tots-toy-drive" className="text-[#00D4FF] font-semibold text-sm tracking-wide hover:text-white transition-colors underline underline-offset-4 decoration-[#00D4FF]/50 hover:decoration-white/50" data-id="element-1179">
            Women's Self Defense Seminar April 18, 2026
          </Link>
        </div>
      </div>
    </nav>;
}